import { request } from './Api';
import { recordActivity, recordEntityChange } from './ActivityService';

export async function listTrash() {
    const response = await request('/api/admin/trash');
    return Array.isArray(response.data)
        ? response.data
        : Array.isArray(response.items) ? response.items : [];
}

export async function restoreTrash(uuid) {
    const response = await request(`/api/admin/trash/${encodeURIComponent(uuid)}/restore`, {
        method: 'POST'
    });
    const restoredItem = response.data || {};
    const entityType = String(restoredItem.type || restoredItem.resource || '').toLowerCase();
    if (entityType === 'user' || entityType === 'model') recordEntityChange(entityType, 1);
    recordActivity({
        type: 'trash',
        action: `Restored ${entityType || 'item'} from trash`,
        entityType: entityType || 'trash',
        entityUuid: uuid
    });
    return response.data;
}

export async function permanentlyDeleteTrash(uuid) {
    const response = await request(`/api/admin/trash/${encodeURIComponent(uuid)}`, {
        method: 'DELETE'
    });
    recordActivity({ type: 'trash', action: 'Permanently deleted trash item', entityType: 'trash', entityUuid: uuid });
    return response.data;
}
